import { createAction, props } from '@ngrx/store';

export enum ConnectivityActionTypes {
  ChangeNetworkConnectivity = '[Network Connectivity] ChangeNetworkConnection',
  HasNetworkConnection = '[Network Connectivity] HasNetworkConnection',
  NoNetworkConnection = '[Network Connectivity] NoNetworkConnection',
}

export const changeWifiConnectivityAction = createAction(ConnectivityActionTypes.ChangeNetworkConnectivity, props<{ status: boolean }>());
export const hasNetworkConnectionAction = createAction(ConnectivityActionTypes.HasNetworkConnection);
export const noNetworkConnectionAction = createAction(ConnectivityActionTypes.NoNetworkConnection);
